import React from 'react';

import { ProductDetails } from 'app/logic/product/ProductDetails';
import 'app/logic/product/CardProductView.less';
import redCardLogo from 'app/assets/red_card_logo.png';
import _100daysLogo from 'app/assets/100_days_logo.png';
import { CardOrder } from 'app/model/CardOrder';
import { Section } from 'app/component/Section';
import { ConvertingMap } from 'app/utils/ConvertingMap';
import { IntroductionPageStore } from 'app/logic/pages/introduction/IntroductionPageStore';

export interface CardProductViewProps {
    /**
     * Хранилище страницы выбора продукта.
     */
    pageStore: IntroductionPageStore;

    /**
     * Текущая заявка.
     */
    order: CardOrder;
}

/**
 * Блок информации о текущем предожении с условиями по кредитной карте.
 */
export const CardProductView = ({ pageStore, order }: CardProductViewProps) => {
    const PRODUCT_CODE_TO_LOGO: ConvertingMap<string, any> = new ConvertingMap<
        string,
        any
    >([
        ['RKK', redCardLogo],
        ['KKG', _100daysLogo],
    ]);

    const productLogo = PRODUCT_CODE_TO_LOGO.convert(
        pageStore.cardProduct.code,
    );

    return (
        <Section
            className={'productDetailsSection'}
            content={
                <>
                    <ProductDetails
                        cardProduct={pageStore.cardProduct}
                        order={order}
                    />
                    <div className={'productLogo'}>
                        <img
                            className="productLogoImage"
                            src={productLogo}
                            alt={'Изображение кредитной карты'}
                        />
                    </div>
                </>
            }
        />
    );
};
